export default __webpack_public_path__ + "static/media/02.11.060.ddf032f0.png";